module.exports = __webpack_public_path__ + "static/media/pic2.7108704b.jpg";